import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";
import { useInView } from "react-intersection-observer";
import "../assets/style/whyus.css";
import "../assets/style/Responsiveness.css";
import shape3 from "../assets/images/shape-3.png";
import star2 from "../assets/images/star-2.png";
import shape5 from "../assets/images/shape-5.png";

// Lazy Load Lottie Component
const LazyLottie = ({ src }) => {
  const [animationData, setAnimationData] = useState(null);
  const { ref, inView } = useInView({ triggerOnce: true });

  useEffect(() => {
    if (inView) {
      import(`../assets/images/lottie/${src}.json`)
        .then((data) => setAnimationData(data.default))
        .catch((err) => console.error("Failed to load animation", err));
    }
  }, [inView, src]);

  return (
    <div ref={ref}>
      {animationData ? (
        <Lottie animationData={animationData} loop style={{ height: "140px" }} />
      ) : (
        <p>{""}</p>
      )}
    </div>
  );
};

const WhyUs = () => {
  return (
    <div className="why-us tnb">
      <div className="container">
        <div className="small-heading">
          <h4>Why Us</h4>
        </div>
        <div className="big-heading">
          <h5>Why Choose Neosao</h5>
        </div>
        <div className="row">
          <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-3">
            <div className="why-text">
              <div className="why-1">
                <LazyLottie src="ani1" />
              </div>
              <h4>Exceptional Customer Service</h4>
              <p>
                We take great pride in delivering excellent service to our customers.
                We understand how important our customers are to us, so we make
                every effort to assist, guide, and provide the best possible solutions.
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
            <div className="why-text">
              <div className="why-2">
                <LazyLottie src="ani3" />
              </div>
              <h4>High-Performance Software Solutions</h4>
              <p>
                We provide high-quality, technically advanced, and high-performance
                software solutions with tangible results. We create a wide variety
                of web applications, including B2B and B2C eCommerce portals.
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
            <div className="why-text">
              <div className="why-3">
                <LazyLottie src="ani4" />
              </div>
              <h4>Competitive Prices</h4>
              <p>
                We offer the best cutting-edge technologies for software development
                solutions and digital marketing services at a very competitive price.
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
            <div className="why-text">
              <div className="why-4">
                <LazyLottie src="ani2" />
              </div>
              <h4>Dedicated Project Team</h4>
              <p>
                When it comes to managing our customers' tasks, we ensure a
                knowledgeable and dedicated team to complete the tasks. Delivering
                excellence is our company's slogan.
              </p>
            </div>
          </div>
        </div>
        <div className="star">
          <img src={shape3} alt="Star" />
        </div>
        <div className="star2">
          <img src={star2} alt="Star" />
        </div>
        <div className="star3">
          <img src={shape5} alt="Star" />
        </div>
      </div>
    </div>
  );
};

export default WhyUs;
